export default function CondenseLogo({ height = 36, className = "", color = "#ffffff", accentColor = "#22c55e" }) {
  const scale = height / 40;
  const iconSize = height * 0.75;
  return (
    <span className={`condense-logo ${className}`} style={{ display: "inline-flex", alignItems: "center", gap: 8 * scale }}>
      <svg viewBox="0 0 32 32" fill="none" style={{ width: iconSize, height: iconSize }}>
        <circle cx="16" cy="16" r="14" stroke={accentColor} strokeWidth="2.5" />
        <polygon points="13,10 23,16 13,22" fill={accentColor} />
      </svg>
      <span style={{
        fontFamily: "'Inter', -apple-system, BlinkMacSystemFont, sans-serif",
        fontWeight: 700,
        fontSize: height * 0.55,
        letterSpacing: "-0.02em",
        color,
        lineHeight: 1,
        whiteSpace: "nowrap",
      }}>
        Condense
      </span>
    </span>
  );
}
